import { Component, OnInit } from '@angular/core';
import { SettingsService } from '@app/settings.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './modal-phone-number.component.html',
  styleUrls: ['./modal-phone-number.component.scss'],
})
export class ModalPhoneNumberComponent implements OnInit {
  phone$: Observable<string>;

  constructor(
    private settingsService: SettingsService,
    private _dialogRef: DynamicDialogRef,
  ) {}

  ngOnInit(): void {
    this.phone$ = this.settingsService.getSettingsByKey('call_center').pipe(map((res) => res[0]?.val));
  }

  close() {
    this._dialogRef.close();
  }
}
